// @ts-ignore
import {IApiResponseSettings} from "../interfaces/apiResponseInterfaces/IApiResponseSettings.interface";

const socialAuth = {
    prefix: 'socialAuth.',
    namespaced: true,
    state: <IApiResponseSettings>{
        google_login: null,
        google_id: null,
        google_secret: null,
        google_uri: null,
        facebook_login: null,
        facebook_id: null,
        facebook_secret: null,
        facebook_uri: null,
        enable_login_setting: null,
        enable_registration_setting: null
    },
    mutations: {
        INITIALIZE(state: IApiResponseSettings) {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {
                let value = localStorage.getItem(socialAuth.prefix + prop);

                if (value) {
                    state[prop] = JSON.parse(value);
                }
            }
        },
        SET_STATE_PROP_VALUE(state, payload: {prop: string, value: any}[]): void {

            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                const value = obj.value;

                state[prop] = value;

                localStorage.removeItem(socialAuth.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(socialAuth.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },
        CLEAR_STATE(state: IApiResponseSettings): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(socialAuth.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }
    },
    actions: {

    },
}

export default socialAuth;